import React from 'react'
import { NavLink } from 'react-router-dom'

import { RoutePath } from '@/routes'

import { LogoLottie } from '../common/Lottie'

const LogoWithName: React.FC = () => {
  return (
    <NavLink to={RoutePath.HOME} className="flex items-center">
      <LogoLottie />
    </NavLink>
  )
}

export default LogoWithName
